import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Service } from "../service.class";
import { SaleModel } from "../../../shared/entities/sale.model";
import { ClientModel } from "../../../shared/entities/client.model";

@Injectable({
	providedIn: "root",
})
export class SalesService {
	private server_path: string = "/v2/sales";

	constructor(private service: Service) {}

	public getSales(client?: string): Observable<{ data: SaleModel[] }> {
		return this.service.apiGetWithoutHeaders(this.server_path, {
			paginate: false,
			client,
		});
	}

	public getClientBySaleId(id: string): Observable<ClientModel> {
		return this.service.apiGetWithoutHeaders(this.server_path + "/client/data/" + id, {});
	}

	public getSaleByOrderId(order_id: string): Observable<SaleModel> {
		return this.service.apiGetWithoutHeaders(this.server_path, {
			textSearch: order_id,
		});
	}

	public patchSaleModelById(sale: SaleModel, body: any): Observable<SaleModel> {
		return this.service.apiPatchWithoutHeaders(this.server_path + "/" + sale._id, body);
	}
}
